






































import "./goal-card.less";
import Vue from "vue";
import { mapGetters } from "vuex";
import AddClassHover from "./../common/add-class-hover.js";

export default Vue.extend({
  name: "goal-card",
  props: {
    id: String,
    goal: Object,
    archivedOrDeleted: Boolean,
  },
  directives: { AddClassHover },
  computed: {
    ...mapGetters("goal", ["canEdit"]),
    colorClass() {
      let trackingResult = (this as any).goal.result;
      if (isNaN(trackingResult) || trackingResult === null) {
        return {
          "bio-card-default": true,
        };
      } else {
        return {};
      }
    },
    textColor() {
      let color = (this as any).color ? (this as any).color.toUpperCase() : (this as any).color;
      return !color || color === "#FFFFFF" || color === "#F5F2EE" ? "#515A6E" : "#FFFFFF";
    },
    color() {
      let context = this as any;

      //if (context.goal.result === null || isNaN(context.goal.result)) {
      //  return "#808080";
      //}

      let result = context.goal.result;
      if (result === null || isNaN(result)) {
        result = 0;
      }

      if (context.goal.archived === true) {
        return "#808080";
      }

      let grades = context.goal && context.goal.gradeModel ? JSON.parse(context.goal.gradeModel) : [];
      grades = grades.sort(function (a, b) {
        return b.from - a.from;
      });

      grades = grades.filter((grade) => context.goal.result * 100 >= grade.from);

      return grades.length > 0 ? grades[0].color : "#808080";
    },
    resultPercentage() {
      let context = this as any;
      if (context.goal && context.goal.result !== null && !isNaN(context.goal.result)) {
        var percentage = Math.round(context.goal.result * 100);
        return `${percentage}%`;
      } else {
        //return "NS";
        return "0%";
      }
    },
  },
  methods: {
    handleCardClick() {
      this.$router.push({ name: "goal", params: { id: this.goal.id } });
    },
    handleMenuItemClick(name) {
      this.$emit(name);
    },
  },
});
